import { RollingNumber } from './RollingNumber';

interface FmvCaptionProps {
  fmv: number;
  /** Defer the inline odometer until the caption is on screen —
   *  see `RollingNumber.start`. */
  roll: boolean;
  /** Returning view — render the FMV value as static text with no
   *  roll. Forwarded to the inner `RollingNumber`. */
  instant?: boolean;
}

/**
 * Small subdued line that sits above PROFIT — "Fair Market Value
 * $X.XX". Lives in its own file so the orchestrator can fade it
 * in on its own beat, independent of the big PROFIT line below.
 */
export function FmvCaption({ fmv, roll, instant = false }: FmvCaptionProps) {
  return (
    <span
      data-co-component="WinnerStepFMV"
      className="leading-[22px]"
      style={{
        color: 'var(--co-WinnerStepFMV-color, rgba(255,255,255,0.60))',
        fontFamily:
          'var(--co-WinnerStepFMV-font, "Inter"), Inter, sans-serif',
        fontSize: 'var(--co-WinnerStepFMV-size, 14px)',
      }}
    >
      Fair Market Value $<RollingNumber value={fmv} start={roll} instant={instant} />
    </span>
  );
}
